// Hardcoded points of interest per community for the community maps.
// Coordinates are approximate but real Dubai landmarks.
export const AREA_POIS = {
  "downtown-dubai": [
    { name: "Burj Khalifa", category: "landmark", lat: 25.1972, lng: 55.2744 },
    { name: "The Dubai Mall", category: "mall", lat: 25.1972, lng: 55.2789 },
    { name: "Burj Khalifa/Dubai Mall Metro", category: "metro", lat: 25.2016, lng: 55.2793 },
    { name: "Dubai Opera", category: "landmark", lat: 25.1929, lng: 55.2716 },
    { name: "GEMS Wellington Primary", category: "school", lat: 25.1899, lng: 55.2607 },
    { name: "Mediclinic Dubai Mall", category: "hospital", lat: 25.1973, lng: 55.2790 },
  ],
  "palm-jumeirah": [
    { name: "Atlantis The Royal", category: "landmark", lat: 25.1300, lng: 55.1200 },
    { name: "Nakheel Mall", category: "mall", lat: 25.1129, lng: 55.1391 },
    { name: "Palm Monorail — Atlantis", category: "metro", lat: 25.1288, lng: 55.1170 },
    { name: "Redwood Montessori Nursery", category: "school", lat: 25.1057, lng: 55.1394 },
    { name: "The View at The Palm", category: "landmark", lat: 25.1129, lng: 55.1382 },
    { name: "Emirates Hospital — Palm", category: "hospital", lat: 25.1054, lng: 55.1387 },
  ],
  "dubai-marina": [
    { name: "Marina Mall", category: "mall", lat: 25.0777, lng: 55.1401 },
    { name: "DMCC Metro", category: "metro", lat: 25.0669, lng: 55.1394 },
    { name: "Emirates International School", category: "school", lat: 25.0784, lng: 55.1516 },
    { name: "JBR Beach", category: "landmark", lat: 25.0805, lng: 55.1341 },
    { name: "Al Zahra Hospital", category: "hospital", lat: 25.0728, lng: 55.1421 },
  ],
  "business-bay": [
    { name: "Bay Avenue", category: "mall", lat: 25.1859, lng: 55.2607 },
    { name: "Business Bay Metro", category: "metro", lat: 25.1858, lng: 55.2634 },
    { name: "JW Marriott Marquis", category: "landmark", lat: 25.1855, lng: 55.2665 },
    { name: "Marasi Promenade", category: "landmark", lat: 25.1877, lng: 55.2637 },
    { name: "Nord Anglia International", category: "school", lat: 25.1701, lng: 55.2795 },
  ],
  "difc": [
    { name: "Gate Avenue at DIFC", category: "mall", lat: 25.2149, lng: 55.2802 },
    { name: "Emirates Towers Metro", category: "metro", lat: 25.2170, lng: 55.2822 },
    { name: "DIFC Sculpture Park", category: "landmark", lat: 25.2147, lng: 55.2820 },
    { name: "Horizon International School", category: "school", lat: 25.2100, lng: 55.2820 },
    { name: "Emirates Hospital Clinics DIFC", category: "hospital", lat: 25.2153, lng: 55.2811 },
  ],
  "mbr-city": [
    { name: "Meydan Racecourse", category: "landmark", lat: 25.1584, lng: 55.3079 },
    { name: "The Track Meydan", category: "landmark", lat: 25.1610, lng: 55.3010 },
    { name: "North London Collegiate School", category: "school", lat: 25.1580, lng: 55.3080 },
    { name: "Crystal Lagoon", category: "landmark", lat: 25.1584, lng: 55.2965 },
    { name: "King's College Hospital", category: "hospital", lat: 25.1670, lng: 55.2950 },
  ],
};
